export default __webpack_public_path__ + "static/media/themebel_main_mobile_small.ae001bab.svg";